<div>
    <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.items.add_an_item' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">

    <div class="row">
        <div class="col-lg-12 input-control">
            <hub-input [(ngModel)]="item.manufacturer" label="{{'general.headers.manufacturer' | translate}}*"
                [autofocus]="true"></hub-input>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 input-control">
            <hub-input [(ngModel)]="item.model" label="{{'general.headers.model' | translate}}*"
                ></hub-input>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 input-control" *ngIf="partnerType !== 'clothing'">
            <hub-input [(ngModel)]="item.modelYear" label="{{'general.headers.year' | translate}}"
                ></hub-input>
        </div>
    </div>
     <div class="row">
      <div class="col-lg-12 input-control">
        <hub-input [(ngModel)]="item.bikeSize"
                   label="{{'bikeshop.rentals.products.size' | translate}}"></hub-input>
      </div>
    </div>
    <div class="row">
        <div class="col-lg-12 input-control">
            <hub-input *ngIf="partnerTypeID!==11 && partnerTypeID!==2" [(ngModel)]="item.colour" label="{{'bikeshop.modal.shared.bike.color' | translate}}"></hub-input>
            <hub-text-area *ngIf="partnerTypeID===11||partnerTypeID===2" [(ngModel)]="item.colour" label="{{'bikeshop.modal.shared.bike.color' | translate}}"></hub-text-area>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 input-control">
            <hub-input [(ngModel)]="item.serialNo" label="{{'bikeshop.rentals.products.serial_number' | translate}}"
                ></hub-input>
        </div>
    </div>
    <div class="row" *ngIf="partnerType === 'bicycle'">
        <div class="col-lg-12 input-control">
            <hub-dropdown [options]="itemTypes" [(ngModel)]="item.typeID" label="{{'general.headers.type' | translate}}"
                ></hub-dropdown>
        </div>
    </div>


</div>
<div class="modal-footer-container">
    <div class="button-container">
        <hub-button [text]="'bikeshop.shop_profile.collections.buttons.add' | translate"
            [style]="'secondary'" [disabled]="!isValidItem() || updating" [loading]="updating"
            (buttonClick)="createItem()" [size]="'xl'"></hub-button>
    </div>
    <div class="short-cut-container">
        <div>
            {{'bikeshop.workshop.jobcard.quote.to_navigate' | translate}}
        </div>
        <div>
            <span><daz-icon [name]="'enter'" [size]="'18px'"
                    [color]="'#6B728C'"></daz-icon></span>{{'bikeshop.workshop.jobcard.quote.to_save_and_close' |
            translate}}
        </div>
    </div>
</div>
